import React from 'react';

// Material UI
import {TableCell, TableSortLabel} from "@mui/material";

// Assets
import {greyishBlue50} from "assets/jss/main";
import TableArrowDesc from "assets/img/wms/table-arrow-desc.svg";

function TableCellHead({
    sortable = false,
    selectedOrderBy = false,
    orderDirection = 'asc',
    onClick = () => {},
    ...props
}) {
    const ArrowDescIcon = () => (
        <img src={TableArrowDesc} />
    );

    const ArrowAscIcon = () => (
        <img
            src={TableArrowDesc}
            style={{
                rotate: '180deg',
            }}
        />
    );

    return (
        <TableCell
            align={'left'}
            sx={{
                background: greyishBlue50,
                borderBottom: 'unset'
            }}
            {...props}
        >
            {sortable ? (
                <TableSortLabel
                    active={selectedOrderBy}
                    direction={orderDirection}
                    onClick={onClick}
                    sx={{
                        marginRight: '10px',
                        'img' : {
                            display: selectedOrderBy ? 'block' :'none',
                        },
                        '&:hover': {
                            'img' : {
                                display: 'block',
                                opacity: 0.5,
                            },
                        },
                    }}
                    IconComponent={(orderDirection === 'desc' ? ArrowDescIcon : ArrowAscIcon)}
                >
                    {props.children}
                </TableSortLabel>
            ) :
                props.children
            }
        </TableCell>
    );
}

export default TableCellHead;
